import request from "@/utils/request";

// 开启云录制
export function startMCUMixTranscodeAPI(params) {
  return request({
    url: "/service/trtc/enable/cloud/cording",
    method: "get",
    params,
  });
}
// 关闭云录制
export function stopMCUMixTranscodeAPI(params) {
  return request({
    url: "/service/trtc/close/cloud/cording",
    method: "get",
    params,
  });
}
// ai调解判断是否需要排队
export function aiVideoLockAPI() {
  return request({
    url: "/service/trtc/aiVideoLock",
    method: "get",
  })
}

// 开启数字人云录制
export function startMCUAiMixTranscodeAPI(data) {
  return request({
    url: "service/trtc/ai/enable/cloud/cording",
    method: "post",
    data,
  });
}
// 获取远端用户信息
export function getVideoUserListAPI(data) {
  return request({
    url: "service/trtc/getVideoUserList",
    method: "post",
    data,
  });
}

